import { BaseForRestoreVMHelper } from 'wizards/helpers/bases/base-for-restore-vm-helper';

export class RestoreHyperVModelForStepsHelper extends BaseForRestoreVMHelper {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected static setSpecificStepsData(newPlan: unknown): void {
    // Here specific data
  }
}
